/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetNewsList200ResponseDataArticlesInnerThumbnailInner
 */
export interface GetNewsList200ResponseDataArticlesInnerThumbnailInner {
  /**
   *
   * @type {string}
   * @memberof GetNewsList200ResponseDataArticlesInnerThumbnailInner
   */
  conversionName: string
  /**
   *
   * @type {string}
   * @memberof GetNewsList200ResponseDataArticlesInnerThumbnailInner
   */
  url: string
  /**
   *
   * @type {number}
   * @memberof GetNewsList200ResponseDataArticlesInnerThumbnailInner
   */
  width: number
  /**
   *
   * @type {number}
   * @memberof GetNewsList200ResponseDataArticlesInnerThumbnailInner
   */
  height: number
}

/**
 * Check if a given object implements the GetNewsList200ResponseDataArticlesInnerThumbnailInner interface.
 */
export function instanceOfGetNewsList200ResponseDataArticlesInnerThumbnailInner(
  value: object
): value is GetNewsList200ResponseDataArticlesInnerThumbnailInner {
  if (!('conversionName' in value) || value['conversionName'] === undefined)
    return false
  if (!('url' in value) || value['url'] === undefined) return false
  if (!('width' in value) || value['width'] === undefined) return false
  if (!('height' in value) || value['height'] === undefined) return false
  return true
}

export function GetNewsList200ResponseDataArticlesInnerThumbnailInnerFromJSON(
  json: any
): GetNewsList200ResponseDataArticlesInnerThumbnailInner {
  return GetNewsList200ResponseDataArticlesInnerThumbnailInnerFromJSONTyped(
    json,
    false
  )
}

export function GetNewsList200ResponseDataArticlesInnerThumbnailInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetNewsList200ResponseDataArticlesInnerThumbnailInner {
  if (json == null) {
    return json
  }
  return {
    conversionName: json['conversionName'],
    url: json['url'],
    width: json['width'],
    height: json['height'],
  }
}

export function GetNewsList200ResponseDataArticlesInnerThumbnailInnerToJSON(
  value?: GetNewsList200ResponseDataArticlesInnerThumbnailInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    conversionName: value['conversionName'],
    url: value['url'],
    width: value['width'],
    height: value['height'],
  }
}
